import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useStore } from "@/stores";
import { showSuccess } from "@/utils/UI";
import { API_BIS_LISTLAYOUT } from "@/configs/Apis";
import DuduAjax from "@/utils/DuduAjax";


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnConfigDialog',
  emits: ["saved"],
  setup(__props, { expose, emit }) {



const store = useStore();

const visible = ref(false);

const colSelector = ref<any>(null);

const listLayout = computed<Array<any>>(() => JSON.parse((store.state as any).project.listLayout || "[]"));

const configedColumns = computed(() => listLayout.value.filter((col: any) => col.hidden !== true));

const hiddenColumns = computed(() => listLayout.value.filter((col: any) => col.hidden === true));

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const closeDialog = () => {
  visible.value = false;
};

const open = () => {
  visible.value = true;
};

expose({ open });

const saveColumnConfig = () => {
  const selector = colSelector.value as any;
  const hiddenItems: Array<any> = selector.getSelectedItems();
  const allColumns: Array<any> = selector.getListData();

  if (hiddenItems && hiddenItems.length) {
    hiddenItems.forEach((col: any) => {
      col.hidden = true;
    });
  }

  allColumns.forEach((col: any) => {
    col.hidden = false;
  });
  const newListLayout = JSON.stringify(allColumns.concat(hiddenItems));
  return DuduAjax.post(API_BIS_LISTLAYOUT, {
    listName: "PATENT",
    layout: newListLayout,
    projectId: projectId.value,
  }).then(() => {
    showSuccess("保存成功");
    closeDialog();
    store.dispatch("project/setListLayout", { id: projectId.value }).then(() => {
      emit("saved");
    });
  });
};

return { __sfc: true,emit, store, visible, colSelector, listLayout, configedColumns, hiddenColumns, projectId, closeDialog, open, saveColumnConfig }
}

})